module.exports = __webpack_public_path__ + "img/sm3_maskFIT_l.ccffb930.png";